import styles from "./button.module.css";

import { cva, type VariantProps } from "class-variance-authority";
import { type ButtonHTMLAttributes, forwardRef } from "react";

const buttonVariants = cva(styles.btn, {
  variants: {
    variant: {
      default: styles.custom_default,
      destructive: styles.custom_destructive,
      outline: styles.custom_outline,
      secondary: styles.custom_secondary,
      ghost: styles.custom_ghost,
      link: styles.custom_link,
    },
    size: {
      default: styles.custom_default_size,
      sm: styles.custom_sm_size,
      lg: styles.custom_lg_size,
      icon: styles.custom_icon_size,
    },
  },
  defaultVariants: {
    variant: "default",
    size: "default",
  },
});

export interface ButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant, size, ...props }, ref) => {
    return (
      <button
        className={buttonVariants({ variant, size })}
        ref={ref}
        {...props}
      />
    );
  }
);

Button.displayName = "Button";

export { Button };
